import { render, staticRenderFns } from "./WCaborder.vue?vue&type=template&id=5c8b2b4e&scoped=true"
import script from "./WCaborder.vue?vue&type=script&lang=js"
export * from "./WCaborder.vue?vue&type=script&lang=js"
import style0 from "./WCaborder.vue?vue&type=style&index=0&id=5c8b2b4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8b2b4e",
  null
  
)

export default component.exports